import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import useMobile from 'utils/useMobile';
import { Link as RouterLink } from 'react-router-dom';
import { ROUTE_SIGN_UP } from 'routes/routes';
import { Image } from 'cloudinary-react';

// @ts-ignore
const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: 128,
    margin: 0,
    width: '100%'
  },
  link: {
    textDecoration: 'underline',
    marginTop: 16
  },
  img: {
    width: '100%',
    display: 'block'
  },
  imgContainer: {
    maxHeight: 400,
    overflow: 'hidden'
  },
  '@media (max-width:1000px)': {
    img: {
      paddingRight: 0,
      maxWidth: '100%',
      paddingLeft: 0
    },
    content: {
      marginTop: 64
    }
  },
  content: {
    paddingRight: 32,
    paddingLeft: 32
  }
}));

const SectionPrinciple = ({ reverse = false, title, description, cdnId }) => {
  const classes = useStyles({})
;
  const isMobile = useMobile();
  const items = [
    <Grid key="1" className={classes.imgContainer} xs={isMobile ? 12 : 7} item>
      <Image className={classes.img} publicId={cdnId} />
    </Grid>,
    <Grid key="2" className={classes.content} xs={isMobile ? 12 : 5} item container direction="column" justify="center">
      <Typography variant={isMobile ? 'h5' : 'h3'} gutterBottom>
        {title.toUpperCase()}
      </Typography>
      <Typography variant="body1" gutterBottom paragraph>
        {description}
      </Typography>
      <Button color="primary" variant="contained" component={RouterLink} to={ROUTE_SIGN_UP}>
        Sign Up To Learn More
      </Button>
    </Grid>
  ];
  return (
    <Grid id={title.toLowerCase()} container className={classes.root}>
      {reverse ? items.reverse() : items}
    </Grid>
  );
};

export default SectionPrinciple;
